import Input from "../../../components/Input"
import DateYearSelect from "../../../components/DateYearSelect"
import RTEInput from '../../../components/RichTextEditor'
import { Grid, Stack, Chip, Box, Button} from "@mui/material"

const Experience = ({fieldValues, handleIndexedOnChange, handleAddNew, handleDelete, handleDateField}) => {
    const fields = [
        {name:'job_title', label:'Job Title', type: 'input'},
        {name:'employer', label:'Employer', type: 'input'},
        {name:'start_date', label:'Start Date', type: 'date'},
        {name:'end_date', label:'End Date', type: 'date'},
        {name:'description', label:'Description', type: 'rte'},
    ]
    const handleOnChange = (name, value, index) =>{       
        if(value){
            handleIndexedOnChange('experience', index, name, value)
        }
    }

    const handleRTEChange = (value, name, index) =>{
        if(value){
            handleIndexedOnChange('experience', index, name, value)
        }
    }

    const handleDate = (name, value, index, key) =>{
        handleDateField('experience', index, name, value, key)
    }

    return <Grid container>
          <Grid item xs={12} px={3} display={'flex'} justifyContent={'space-between'}>
        <Stack direction="row" spacing={1}>{fieldValues['experience'].map((values, index)=>{
                return <Chip label={`Experience ${index + 1}`} onDelete={()=>handleDelete('experience', index)}/>
            })}</Stack>
            <Box><Button variant="contained" onClick={()=>handleAddNew('experience')}>Add New</Button></Box>
        </Grid>
        {fieldValues['experience'].map((values, fieldIndex)=>{
            return fields.map((field, index)=>{
                return <Grid item xs={field.type === 'rte' ?12 :6} p={3}>
                {field.type === 'date' && <DateYearSelect label={field.label} fieldValues={fieldValues} value={values[field.name]} index={fieldIndex} name={field.name}  handleOnChange={handleDate}/> }
                {field.type === 'input' && <Input name={field.name} label={field.label} value={values[field.name]} key={index} index={fieldIndex} handleOnChange={handleOnChange}/>}
                {field.type === 'rte' && <RTEInput name={field.name} label={field.label} value={values[field.name]} key={index} index={fieldIndex} handleOnChange={handleRTEChange}/>}
             </Grid>
            })
        })}
    </Grid>
}

export default Experience